import * as yup from "yup";

const ReporteRelojChecadorSchema = yup.object({
  branch: yup
    .number()
    .min(0, "Campo requerido")
    .required("Campo requerido")
    // .positive("Campo requerido")
    .integer("Campo requerido"),
  partner: yup
    .number()
    .min(0, "Campo requerido")
    .required("Campo requerido")
    // .positive("Campo requerido")
    .integer("Campo requerido"),

  start: yup
    .date()
    .required("La fecha de inicio es requerida")
    .test(
      "is-before-end-date",
      "La fecha de inicio no puede ser mayor que la fecha de fin",
      function (value) {
        const { endDate } = this.parent;
        return !endDate || value <= endDate;
      }
    ),
  end: yup
    .date()
    .required("La fecha de fin es requerida")
    .test(
      "is-after-start-date",
      "La fecha de fin no puede ser menor que la fecha de inicio",
      function (value) {
        const { startDate } = this.parent;
        return !startDate || value >= startDate;
      }
    ),
});

export default ReporteRelojChecadorSchema;
